import { FDStack } from '@facet-wealth/design';
import MetaField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import React from 'react';
import { LottieLoadingLayout } from 'Organisms/LottieControl/LottieLoadingLayout';
import AccountDetailsSectionPicker
  from 'Views/Page/Content/Templates/RolloverConciergeIntroStepTemplate/Content/AccountDetailsSection/AccountDetailsSectionPicker';
import MainContent from './MainContent/MainContent';

const Layout = () => {
  return (
    <FDStack
      direction={'column'}
      spacing={3}
      paddingY={4}
      justifyContent={'center'}
    >
      <MetaField attr="title" />
      <LottieLoadingLayout>
        <AccountDetailsSectionPicker />
      </LottieLoadingLayout>
      <MainContent />
      <MetaField attr={'disclaimer'} />
    </FDStack>
  );
};

Layout.defaultProps = {};

Layout.propTypes = {};

export default Layout;
